import { CURRENCY_CODE, CURRENCY_SYMBOLS } from '@ps/utils';
import {
  CHILD_AGE_UNIT_CODE,
  QUALIFICATION_CODE,
} from '../../constants/qualification.constants';
import { ChildrenLabelMapper } from 'purespectrum-lib';
import { QuotaCriteria, QuotaRangeSet } from '../../models/survey-quota.model';

export function formatCurrencyRange(rangeItem: QuotaRangeSet): string {
  const symbol = CURRENCY_SYMBOLS[rangeItem.units] ?? '';
  const isPrefixCurrency =
    rangeItem.units >= CURRENCY_CODE.US && rangeItem.units <= CURRENCY_CODE.AU;

  return isPrefixCurrency
    ? `${symbol}${rangeItem.from} - ${symbol}${rangeItem.to}`
    : `${rangeItem.from} ${symbol} - ${rangeItem.to} ${symbol}`;
}

export function generateQuotaTitle(input: QuotaCriteria[]): string {
  return input
    .flatMap((item) => {
      const labels: string[] = [];

      if (item.qualificationCode === QUALIFICATION_CODE.CHILD_AGE_GENDER) {
        const mapper = new ChildrenLabelMapper(
          item.conditionCodes?.map(Number),
          item.childAgeUnit ?? CHILD_AGE_UNIT_CODE.YEARS,
        );
        labels.push(mapper.label());
      } else if (item.conditionNames?.length && !item.rangeSets?.length) {
        labels.push(...item.conditionNames);
      }

      if (item.rangeSets?.length) {
        labels.push(...item.rangeSets.map(formatCurrencyRange));
      }

      return labels;
    })
    .join(',');
}
